import { Type } from 'class-transformer';
import { UserDashboardItemResultDto } from './user-dashboard-item-result-dto';

export class UserDashboardResultDto {
    title: string;
    open: number;
    priority: number;
    problematic: number;

    @Type(() => UserDashboardItemResultDto)
    items: UserDashboardItemResultDto[];

    get actualOpen(): number {
        return Math.max(0, this.open - this.priority - this.problematic);
    }
}
